module.exports = __webpack_public_path__ + "static/images/cover_B1.4212d6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_B1.png
// module id = fCks
// module chunks = 8